var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.avatar
    ? _c(
        "div",
        { staticClass: "outerBorder rounded-full cursor-pointer" },
        [
          _c("S3Image", {
            staticClass:
              "inline-block h-10 w-10 rounded-full object-cover object-center innerBorder",
            attrs: { s3FileKey: _vm.avatar },
          }),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "outerBorder rounded-full" },
        [
          _c("CircleWithInitials", {
            attrs: {
              customClass: "innerBorder flex items-center content-center",
              primary: "",
              cursorPointer: _vm.pointer,
              large: "",
              title: _vm.title,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }